if (!customElements.get('search-paper')) {
  class searchPaper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // 延迟 50ms 确保 DOM 完全挂载计算
      setTimeout(() => this.init(), 50);
    }
    init() {
      const that = this;
      this.isPC = window.innerWidth > 768;

      this.searchInput = this.querySelector("#search-paper-input");
      this.collectionTab = this.isPC ? this.querySelectorAll('.tab-collection-wrapper') : this.querySelectorAll('.navList');
      this.collectionTabEl = this.isPC ? this.querySelector(".filter_warpper_tab_pc") : this.querySelector(".filter_warpper_tab_moblie");
      this.prodWrapper = this.isPC ? this.querySelector(".products") : this.querySelector(".filter-moblie-wrapper-content");
      this.noResultEl = this.isPC ? this.querySelector(".noResultText") : this.querySelector(".noResultText_Mobile");
      this.prodListContainer = this.isPC ? this.querySelectorAll(".tab-product") : this.querySelectorAll(".tab-product-moblie");
      this.prodListContainerData = [];
      this.backTextEl = this.querySelector(".backText");
      
      this.scrollContent = this.querySelector("#scrollContent");
      this.arrow_left_btn = this.querySelector(".arrow_left");
      this.arrow_right_btn = this.querySelector(".arrow_right");
      this.sreachBtn = this.querySelector(".sreachBtn");

      // 选中的 Tab 默认定位
      const activeTabEl = this.querySelector(".active");
      this.activeTab = activeTabEl ? activeTabEl.dataset.tabName : 'collection-type-1';

      this.collectionTabFn(this.activeTab);

      this.searchInput?.addEventListener("keyup", function (e) {
        if (!e.target.value) {
          that.collectionTabFn(that.activeTab);
        }
      });

      this.prodListContainer.forEach((item) => {
        item.addEventListener("click", function (e) {
          // 防止点中子元素阻止跳转
          if (e.target.closest('.arrowBtn')) return;
          that.goPage(e.currentTarget.dataset.url);
        });
        this.prodListContainerData.push({
          "title": item.dataset.title,
          "prodindex": item.dataset.tabIndex,
        });
      });

      this.sreachBtn?.addEventListener("click", function () {
        that.searchPaperFn(that.searchInput.value);
      });

      this.collectionTab.forEach((item) => {
        item.addEventListener("click", function (e) {
          e.stopPropagation();
          const tabName = e.currentTarget.dataset.tabName;
          if (tabName) {
            that.collectionTabFn(tabName);
          }
        });
      });

      this.backTextEl?.addEventListener("click", function () {
        if (that.searchInput) that.searchInput.value = "";
        that.collectionTabFn(that.activeTab);
      });
      
      // 绑定左右点击滚动事件（增加 stopPropagation 隔离）
      this.arrow_left_btn?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.doScroll(-350);
      });

      this.arrow_right_btn?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();    
        this.doScroll(350);
      });

      if (this.isPC && this.scrollContent) {
        this.scrollContent.addEventListener('scroll', () => {
          this.isShowArrowFn();
        }, { passive: true });
        
        setTimeout(() => this.isShowArrowFn(), 200);
      }
    }
    doScroll(offset) {
      if (!this.scrollContent) return;
      this.scrollContent.scrollBy({
        left: offset,
        behavior: 'smooth'
      });
      setTimeout(() => this.isShowArrowFn(), 350);
    }

    searchPaperFn(keyword) {
      if (!keyword) return;
      keyword = keyword.toUpperCase().replace(/\s/g, '');
      let fullResult = this.prodListContainerData.filter(item => item.title && keyword === item.title.replace(/\s/g, ''));
      let includeResult = this.prodListContainerData.filter(item => item.title && item.title.toUpperCase().replace(/\s/g, '').includes(keyword));
      let includeResult2 = this.prodListContainerData.filter(item => item.title && keyword.includes(item.title.toUpperCase().replace(/\s/g, '')));
      let sreachResult = fullResult.concat(includeResult).concat(includeResult2);

      if (sreachResult.length === 0) {
        this.ResultFN(false);
        return;
      }

      this.ResultFN(true);
      this.prodListContainer.forEach((item) => {
        if (sreachResult.findIndex(citem => citem.prodindex === item.dataset.tabIndex) > -1) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }

    collectionTabFn(index) {
      this.ResultFN(true, 1);
      this.activeTab = index;

      this.collectionTab.forEach((item) => {
        const isCurrentActive = item.dataset.tabName === this.activeTab;

        if (this.isPC) {
          if (isCurrentActive) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        } else {
          const innerTab = item.querySelector('.left_tab');
          if (isCurrentActive) {
            item.classList.add("active");
            if (innerTab) {
              innerTab.style.backgroundColor = '#FFE8E8';
              innerTab.style.borderLeft = '4px solid #FF4D12';
              innerTab.style.color = '#000000';
              innerTab.style.fontWeight = 'bold';
            }
          } else {
            item.classList.remove("active");
            if (innerTab) {
              innerTab.style.backgroundColor = '#f2f2f2';
              innerTab.style.borderLeft = 'none';
              innerTab.style.color = '#374151';
              innerTab.style.fontWeight = '500';
            }
          }
        }
      });

      // 根据选中的 Tab 过滤下方的商品卡片
      this.prodListContainer.forEach((item) => {
        if (item.dataset.tabName === index) {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      });

      // 重置滚动条位置
      if (this.isPC && this.scrollContent) {
        this.scrollContent.scrollLeft = 0;
        setTimeout(() => this.isShowArrowFn(), 100);
      }
    }

    isShowArrowFn() {
      if (!this.scrollContent) return;

      const scrollLeft = this.scrollContent.scrollLeft;
      const maxScroll = this.scrollContent.scrollWidth - this.scrollContent.clientWidth;

      // 如果内容不足以产生滚动，隐去箭头
      if (maxScroll <= 5) {
        this.arrow_left_btn?.classList.add("hide");
        this.arrow_right_btn?.classList.add("hide");
        return;
      }

      // 最左侧：隐藏左，显示右
      if (scrollLeft <= 5) {
        this.arrow_left_btn?.classList.add("hide");
        this.arrow_right_btn?.classList.remove("hide");
      } 
      // 最右侧：显示左，隐藏右
      else if (scrollLeft >= maxScroll - 5) {
        this.arrow_left_btn?.classList.remove("hide");
        this.arrow_right_btn?.classList.add("hide");
      } 
      // 处于中间：左右均显示
      else {
        this.arrow_left_btn?.classList.remove("hide");
        this.arrow_right_btn?.classList.remove("hide");
      }
    }

    ResultFN(hasResult, type) {
      if (this.prodWrapper) {
        hasResult ? this.prodWrapper.classList.remove('hidden') : this.prodWrapper.classList.add('hidden');
      }

      if (this.collectionTabEl) {
        (hasResult && !type) ? this.collectionTabEl.classList.add('hidden') : this.collectionTabEl.classList.remove('hidden');
      }

      if (this.noResultEl) {
        hasResult ? this.noResultEl.classList.add('hidden') : this.noResultEl.classList.remove('hidden');
      }

      if (this.backTextEl) {
        (hasResult && !type) ? this.backTextEl.classList.remove('hidden') : this.backTextEl.classList.add('hidden');
      }

      setTimeout(() => {
        this.isShowArrowFn();
      }, 100);
    }

    goPage(url) {
      if (url) window.location.href = url.includes("https://") ? url : window.location.origin + url;
    }
  }
  customElements.define('search-paper', searchPaper);
}